import React from 'react';
import CallToActionWidget from 'applications/static-pages/cta-widget';

const Form686CTA = () => {
  return (
    <div>
      <CallToActionWidget appId="add-remove-dependents" />
    </div>
  );
};

export default Form686CTA;
